import ConfirmableLink from './ConfirmableLink';
export default ConfirmableLink;